import store from '../store'

const authRoute = (next) => {
  store.dispatch('Auth/initUser')
    .then((data) => {
      if (data) {
        next({ name: 'Top' })
      }
    })
    .catch((err) => { console.log('USER IS NOT LOGIN: ', err) })
}

const initAndCheck = (next, role) => {
  store.dispatch('Auth/initUser')
    .then((data) => {
      if (store.state.Auth.role === role) { next() } else { next({ name: 'Login' }) }
    })
    .catch((err) => { console.log('USER IS NOT LOGIN: ', err) })
}

export const authorizeToken = (to, from, next) => {
  window.stop()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.Auth || !localStorage.getItem('token')) {
      next({ name: 'Login' })
    } else {
      next()
    }
  } else if (to.name === 'Login' && localStorage.getItem('token')) {
    authRoute(next)
  } else {
    next()
  }
}

export const adminCheck = (to, from, next) => {
  if (store.state.Auth.role === 'A') { next() } else { initAndCheck(next, 'A') }
}

export const schoolCheck = (to, from, next) => {
  if (store.state.Auth.role === 'SC') { next() } else { initAndCheck(next, 'SC') }
}

export const tourCompanyCheck = (to, from, next) => {
  if (store.state.Auth.role === 'TC') { next() } else { initAndCheck(next, 'TC') }
}
